let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lCTSk")).then(() => parcelRequire('k46OE'));